import {actions} from './reducer';
import {getParamByName} from './common/Utils';

export default class Router {
    store = {};
    history = window.History;
    isFirst = true;

    constructor(_store={}){
        this.store = _store;
        this.title = $('html head title').text();
        this.history.Adapter.bind(window, 'statechange', () => this.getParamSetData() );
    }
    
    init(){
        this.history.Adapter.trigger(window, 'statechange');
    }

    getParamSetData(){
        this.store.dispatch( actions.setIsParamsLoaded( false ) );

        this.findDispatch('query', actions.setQuery);
        this.findDispatch('job', actions.setJob);
        this.findDispatch('page', actions.setPage);
        
        this.findDispatch('c', actions.setChar);
        this.findDispatch('compare', actions.setCompare);
        
        this.store.dispatch( actions.setIsParamsLoaded( true ) );
    }

    findDispatch(_key, _action){
        let val = getParamByName(_key);
        if (_key==='itemid') {
            val = (val === null)? '': val;
        }
        if (val != null) this.store.dispatch( _action(val) );
    }

    goParam(_newParamObj={}){
        this.changeParam($.param(_newParamObj));
    }
    
    goMultiParam(_newParamObj={}){
        let oldParamObj = {};
        document.location.search.substr(1).split('&').map( it => {
            let key = it.split('=')[0];
            let val = it.split('=')[1];
            if(!val) return '';
            if(key==='query') val = decodeURIComponent(val);
            if(key==='c') val = decodeURIComponent(val);
            oldParamObj[key] = val;
        });
        let lastParam = $.extend(true, oldParamObj, _newParamObj);
        this.changeParam($.param(lastParam));
    }

    changeParam(_paramStr=''){
        this.history.pushState( null, this.title, '?' + _paramStr );
    }

} // end of class


/* 
    History.Adapter.bind(window,'statechange',function(){
        var State = History.getState();
    });
    History.pushState({state:1}, "State 1", "?state=1");
    History.replaceState({state:3}, "State 3", "?state=3");
    History.pushState(null, null, "?state=4");
    History.back();
    History.go(2);
*/